import React, { useState } from "react";
import MuiSelect from "./MuiSelect";
import MuiInput from "./MuiInput";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import { BiImages, BiUpload } from "react-icons/bi";
import { AiOutlineCloseSquare } from "react-icons/ai";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";

const categoryNames = [
  "camera",
  "mobile",
  "laptop",
  "headphone",
  "monitor",
  "electronic",
];
const tagLineNames = [
  "deal of the day",
  "best seller",
  "festival latest launches",
  "normal",
];

const AddForm = ({
  OnSubmitUploadProduct,
  productInfo,
  setProductInfo,
  category,
  setCategory,
  tagline,
  setTagline,
  imageRef,
  setCloudinaryImageFile,
  showImage,
  setShowImage,
  isUploadLoading,
}) => {
  const { shortTitle, longTitle, mrp, cost, description } = productInfo;
  const toastStyle = {
    position: "top-center",
    autoClose: 1000,
  };
  const OnChangeInputValues = (e) => {
    const { name, value } = e.target;
    setProductInfo((previousValue) => {
      return { ...previousValue, [name]: value };
    });
  };
  const OnChangeCategory = (e) => {
    setCategory(e.target.value);
  };
  const OnChangeTagline = (e) => {
    setTagline(e.target.value);
  };
  const onClickImageUploadBtn = (e) => {
    imageRef.current.click();
  };
  //   this onChange function for showing the image in frontend and also setting the cloudinary files
  const setImageForUpload = (e) => {
    const files = e.target.files[0];
    const fileSize = files.size / 1024;
    if (fileSize <= 1024) {
      toast.success("Image uploaded successfully!", toastStyle);

      setShowImage(URL.createObjectURL(files));
      setCloudinaryImageFile(files);
    } else {
      toast.warn(
        "You are not allowed to upload more than 1mb image",
        toastStyle
      );
    }
  };
  const DeleteImage = () => {
    setCloudinaryImageFile("");
    setShowImage("");
    imageRef.current.value = "";
    toast.success("Image deleted successfully!", {
      position: "bottom-right",
      autoClose: 1500,
    });
  };
  return (
    <form onSubmit={OnSubmitUploadProduct} className="admin-add-form-grid-form">
      <div>
        <p style={{ textAlign: "center", fontWeight: "bolder" }}>
          Add New Product
        </p>
        <div className="underline-form-add"></div>
      </div>
      <div className="admin-add-form-grid">
        <div>
          <MuiInput
            inputType="text"
            value={shortTitle}
            onChangeFunction={OnChangeInputValues}
            placeholderTitles="product short title"
            name="shortTitle"
            labelTitle="Product Short Title"
          />
          <MuiInput
            inputType="text"
            value={longTitle}
            onChangeFunction={OnChangeInputValues}
            placeholderTitles="product long title"
            name="longTitle"
            labelTitle="Product Long Title"
          />
          <MuiSelect
            functionName={OnChangeCategory}
            stateName={category}
            data={categoryNames}
            Title="Category"
            labelTitle="category"
          />
          <div className="admin-add-label">
            <label htmlFor="image">Description:</label>
          </div>
          <TextareaAutosize
            name="description"
            onChange={OnChangeInputValues}
            aria-label="minimum height"
            placeholder="Write Product Description..."
            className="admin-add-textarea"
          />
        </div>
        <div>
          <input
            type="file"
            name=""
            id=""
            accept=".png, .jpg, .jpeg, .webp"
            ref={imageRef}
            onChange={setImageForUpload}
            hidden
          />
          <div className="admin-add-label">
            <label htmlFor="image">Add Image:</label>
          </div>
          <div className="div-image-area-btn">
            <div className="inside-image-upload">
              <p>
                <BiImages />
              </p>
              <div className="inside-image-upload-btn">
                <p
                  onClick={onClickImageUploadBtn}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <BiUpload
                    style={{
                      marginRight: "5px",
                      fontSize: "25px",
                      color: "#049bff",
                    }}
                  />
                  Upload Product Image Here
                </p>
              </div>
              {showImage && (
                <div className="image-pos-ab-add ">
                  <img src={showImage} alt="" className="img-pos-ab-inside" />
                  <button
                    onClick={DeleteImage}
                    className="img-pos-ab-inside-btn"
                  >
                    <AiOutlineCloseSquare />
                  </button>
                </div>
              )}
            </div>
          </div>
          <MuiInput
            inputType="number"
            value={mrp}
            onChangeFunction={OnChangeInputValues}
            placeholderTitles="maximum retail price"
            name="mrp"
            labelTitle="mrp"
          />
          <MuiInput
            inputType="number"
            value={cost}
            onChangeFunction={OnChangeInputValues}
            placeholderTitles="product cost"
            name="cost"
            labelTitle="cost"
          />
          <MuiSelect
            functionName={OnChangeTagline}
            stateName={tagline}
            data={tagLineNames}
            Title="Tagline"
            labelTitle="tagline"
          />
        </div>
      </div>
      <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
        <button
          type="submit"
          className="admin-add-submit-btn"
          disabled={isUploadLoading && true}
        >
          {isUploadLoading ? (
            <>
              <CircularProgress size={20} color="info" />
              Uploading...
            </>
          ) : (
            "Add"
          )}
        </button>
      </div>
    </form>
  );
};

export default AddForm;
